<template>
  <div v-loading="loading">
    <Form>
      <Row>
         <Col span="24">
          <FormItem :label="l('SHENQINGREN')">{{item.applyUserName}}</FormItem>
        </Col>
      </Row>
      <Row>
        <Col span="6">
          <FormItem :label="l('JIAOSHIBIANMA')">{{item.code}}</FormItem>
        </Col>
        <Col span="6">
          <FormItem :label="l('JIAOSHIMINGCHENG')">{{item.classRoomName}}</FormItem>
        </Col>
         <Col span="12">
         <FormItem :label="l('SHIYONGSHIJIAN')">{{item.useStartTime}}-{{item.useEndTime}}</FormItem>
        </Col>
      </Row>
      <Row>
        <Col span="24">
          <FormItem :label="l('SHENQINGYUANYING')">{{item.reason}}</FormItem>
        </Col>
      </Row>
    </Form>
  </div>
</template>
<script>
export default {
  name: "classRoomAudit",
  props: ["id"],
  data() {
    return {
      loading: false,
      item: {}
    };
  },
  methods: {
    _fetch(id) {
      if (id) {
        this.loading = true;
        this.http
          .request("sys/trainClassRoomApply/info", { id: id })
          .then(result => {
            this.item = result.item;
          })
          .finally(() => (this.loading = false));
      }
    }
  },
  created: function() {
    this._fetch(this.id);
  }
};
</script>



// WEBPACK FOOTER //
// classRoomAudit.vue?637ad46c